<svelte:options customElement={{ tag: "bt-editable", shadow: "none", }} />

<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';
  import Icon from '$shared/icons/Icon.svelte';
  export let action = '';
  export let contents = '';
  export let styleClass: 'header' | '' = '';
  export let editable: boolean = false;
  export let formStyle = false;
  export let model = '';
  export let placeholder = '';
  export let property = '';
  // Optional character limit, so the box stops accepting text past what the database can save.
  export let maxlength: number | undefined = undefined;
  let editor: HTMLTextAreaElement;
  // timers for typing
  let closeTime = 300;
  let typeTimer = setTimeout(() => {}, 3000);
  var interval = setInterval(() => {}, 10);
  // event bubbling
  const dispatch = createEventDispatcher();
  $: contents, sendChange();
  function handleInput(event: any) {
    setSize();
    if (/[a-zA-Z0-9-_ ]/.test(contents)) {
      clearTimeout(typeTimer);
      closeTime = 300;
      clearInterval(interval);
      interval = setInterval(timerFunction, 10);
      // Closing the box saves it, so the timer only closes it to avoid saving twice.
      typeTimer = setTimeout(() => editor.blur(), 3000);
    } else {
      event.preventDefault();
      return;
    }
  }
  function timerFunction() {
    closeTime--;
    if (closeTime <= 0) {
      clearInterval(interval);
      closeTime = 300;
    }
  }
  function saveContent() {
    let formContents = {};
    formContents[model] = {};
    formContents[model][property] = contents;
    fetch(action, {
      method: "PUT",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      },
      body: JSON.stringify(formContents),
    });
  }
  function finishTyping() {
    saveContent();
    editor.blur();
  }
  function getName() {
    return `${model}[${property}]`;
  }
  function sendChange() {
    dispatch('change', {
      contents: contents
    });
  }
  function setSize() {
    editor.style.height = '0px';
    editor.style.height = editor.scrollHeight + 'px';
  }
  function toggleEditor() {
    if (!editable) return;
    if (editor) formStyle = !formStyle;
    setTimeout(()=>{
      editor.focus();
    }, 0)
  }
  const handleEditorBlur = () => {
    if (!editable) return;
    clearTimeout(typeTimer);
    clearInterval(interval);
    finishTyping();
    toggleEditor();
  }
  const handlePaste = () => {
    setTimeout(()=>{
      saveContent();
    }, 0)
  }
  onMount(() => {
    if (editor) setSize();
  });
</script>

<div class="relative inline-block group w-full" class:is-editable={editable}>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="{styleClass} {editable ? 'group-hover:pl-6 transition-all': ''}"
    class:hidden={formStyle}
    class:cursor-pointer={editable}
    on:click={toggleEditor}
    aria-label="Click to edit text"
  >
    {#if contents == ''}
      <span class="text-neutral-400">{placeholder}</span>
    {:else}
      {contents}
    {/if}
  </div>
  {#if editable}
    <textarea
      name={getName()}
      class={styleClass}
      style={formStyle ? 'width:100%' : ''}
      class:border-neutral-300={formStyle}
      class:hidden={!formStyle}
      class:hover:border-neutral-300={formStyle}
      class:-ml-0={formStyle}
      {maxlength}
      placeholder={placeholder}
      on:blur={handleEditorBlur}
      on:input={handleInput}
      on:paste={handlePaste}
      bind:this={editor}
      bind:value={contents}
    />
    <div
      class:hidden={formStyle}
      class="absolute top-0 left-0 h-full flex items-center justify-center opacity-0 transition-all pointer-events-none {editable ? 'group-hover:opacity-100':''}"
    >
      <Icon icon="Edit" size="small" />
    </div>
  {/if}
</div>

<style>
  textarea {
    resize: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  textarea::-webkit-scrollbar {
    display: none;
  }
  .header {
    font-weight: 600;
    font-family: theme('fontFamily.sans');
    line-height: 1.25;
    font-size: theme('fontSize.2xl');
    transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .is-editable .header {
    cursor: pointer;
  }
</style>